import { TFunction } from 'i18next';
import { DomainPreferences } from '../../../../../../api/types';
import { DataFieldValueFormatter } from '../../../../../hooks';
import {
  DataVizContainerCommonUtils,
  KpiSectionValue,
} from '../../../common/types';
import {
  extractMetaFromSection,
  getKpiUiSectionInputsFromKpiSectionValue,
} from '../../../common/utils';
import {
  KpiFactboxTwoMetricVizData,
  KpiFactboxTwoMetricVizExternalProps,
} from '../../types';
import { KpiTwoColumnUiComponentProps } from './types';

type TwoColumnFactboxSection =
  KpiTwoColumnUiComponentProps['componentProps']['options']['sections']['leftSection'];

const getSection = (
  section: KpiSectionValue,
  preferences: DomainPreferences,
  t: TFunction,
  dataFieldValueFormatter: DataFieldValueFormatter
): TwoColumnFactboxSection => {
  const { mainValue, subValues } = getKpiUiSectionInputsFromKpiSectionValue(
    section,
    preferences,
    t,
    dataFieldValueFormatter
  );
  const singleMetricSection: TwoColumnFactboxSection = {
    title: section.title,
    mainValue,
    subValues,
  };
  return singleMetricSection;
};

export const twoColumnFactboxDataToUiComponentProps = (
  data: KpiFactboxTwoMetricVizData,
  externalProps: KpiFactboxTwoMetricVizExternalProps,
  { t, dataFieldValueFormatter }: DataVizContainerCommonUtils
): KpiTwoColumnUiComponentProps => {
  const { dataResponse } = data;
  const leftSection = getSection(
    dataResponse.firstSectionValue,
    externalProps.preferences,
    t,
    dataFieldValueFormatter
  );
  const rightSection = getSection(
    dataResponse.secondSectionValue,
    externalProps.preferences,
    t,
    dataFieldValueFormatter
  );

  const meta = [
    ...extractMetaFromSection(dataResponse.firstSectionValue),
    ...extractMetaFromSection(dataResponse.secondSectionValue),
  ];
  const { title, subtitle, footer } = data;
  return {
    meta,
    componentProps: {
      options: {
        title: title,
        subtitle: subtitle,
        footer: footer,
        fontSize: data.fontSize,
        sections: {
          leftSection,
          rightSection,
        },
      },
    },
  };
};
